import { render, staticRenderFns } from "./NccQuestionToolbar.vue?vue&type=template&id=15f2dd26&scoped=true&"
import script from "./NccQuestionToolbar.vue?vue&type=script&lang=js&"
export * from "./NccQuestionToolbar.vue?vue&type=script&lang=js&"
import style0 from "./NccQuestionToolbar.vue?vue&type=style&index=0&id=15f2dd26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f2dd26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/staging.newcitycatechismus.nl/httpdocs/web/app/themes/wp-subsite-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15f2dd26')) {
      api.createRecord('15f2dd26', component.options)
    } else {
      api.reload('15f2dd26', component.options)
    }
    module.hot.accept("./NccQuestionToolbar.vue?vue&type=template&id=15f2dd26&scoped=true&", function () {
      api.rerender('15f2dd26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/QNA/NccQuestionToolbar.vue"
export default component.exports